import { IColumns } from '../../../../../components/Dashboard/TableSmall'

export enum RiskLevel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'staking/baskets',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      // id: 'total',
      id: 'total',
      label: 'TOTAL STAKE',
      // eslint-disable-next-line
      // format: (value: any) => value.toFixed(3),
    },
    {
      id: 'apr',
      label: 'APR',
      // eslint-disable-next-line
      format: (value: any) => Number(value).toFixed(9),
    },
    {
      id: 'riskLevel',
      label: 'RISK LEVEL',
    },
  ],
}
